import { axiosV2 } from "config/@axios";

export const FETCHING = "mfaActions::fetching";
export const SET_ERROR_MESSAGE = "mfaActions::setErrorMessage";
export const FETCH_SUCCESS = "mfaActions::fetchSuccess";
export const RESET = "mfaActions::reset";

export const fetch = () => dispatch => {
  dispatch({ type: FETCHING });
  return axiosV2
    .get("mfa")
    .then(response => {
      dispatch({
        type: FETCH_SUCCESS,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: SET_ERROR_MESSAGE,
        payload: error.message
      });
    });
};
